import { Navigate, Route, Routes } from 'react-router';

import { RedirectWithSuffix } from '../components/RedirectWithSuffix';
import { useSettingsScope } from '../SettingsContext';

import { DataCatalogs } from './sections/DataCatalogs/DataCatalogs';
import { Entities } from './sections/Entities/Entities';
import { Invoicing } from './sections/Invoicing/Invoicing';
import { Members } from './sections/Members/Members';
import { Services } from './sections/Services/Services';
import { Workflows } from './sections/Workflows/Workflows';

export const SettingsOrganization = () => {
  const { scope } = useSettingsScope();

  const canManageOrganization = scope?.permissions.includes('manage_organization');
  const canManageEntities = scope?.permissions.includes('manage_entities');
  const canManageUsers = scope?.permissions.includes('manage_users');
  const canManageBilling = scope?.permissions.includes('manage_billing');

  const defaultSection = canManageUsers
    ? 'team'
    : canManageEntities
      ? 'network'
      : canManageOrganization
        ? 'workflows'
        : canManageBilling
          ? 'billing'
          : null;

  if (!defaultSection) {
    return <Navigate to="/settings_beta/account" replace />;
  }

  return (
    <Routes>
      {canManageUsers && <Route path="team/*" element={<Members />} />}
      {canManageEntities && <Route path="network/*" element={<Entities />} />}
      {canManageOrganization && <Route path="services/*" element={<Services />} />}
      {canManageOrganization && <Route path="workflows/*" element={<Workflows />} />}
      {canManageOrganization && <Route path="catalog/*" element={<DataCatalogs />} />}
      {canManageOrganization && (
        <Route
          path="data-catalogs/condition-forms/*"
          element={<RedirectWithSuffix to="/settings_beta/workflows/condition-forms" />}
        />
      )}
      {canManageBilling && <Route path="billing/*" element={<Invoicing />} />}
      <Route path="*" element={<Navigate to={`/settings_beta/${defaultSection}`} replace />} />
    </Routes>
  );
};
